import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { checkoutUrl } from '../data/toolkit';

const { FiArrowUpRight } = FiIcons;

function CtaButton({ children = 'Get the toolkit', light = false }) {
  return (
    <a
      className={`cta-button${light ? ' cta-button-light' : ''}`}
      href={checkoutUrl}
      target="_blank"
      rel="noreferrer"
    >
      <span>{children}</span>
      <SafeIcon icon={FiArrowUpRight} aria-hidden="true" />
    </a>
  );
}

export default CtaButton;